import { Add } from "@mui/icons-material";
import { useState } from "react";
import { Button, List, SearchInput, SelectInput, TopToolbar, useTranslate } from "react-admin";

import { ROWS_PER_PAGE } from "../constants";
import { useLocationFilterContext } from "../hooks/useLocationFilterContext";
import { useOrganizationContext } from "../hooks/useOrganizationContext";
import { ACCESS_STATUS } from "../lib/accessStatus";
import { EmptyList } from "./EmptyList";
import { ListTitle } from "./ListTitle";
import { PractitionerBulkOtpAction } from "./PractitionerBulkOtpAction";
import { PractitionerCreate } from "./PractitionerCreate";
import { PractitionerDataGrid } from "./PractitionerDataGrid";

const PractitionerListActions = ({ disabled, onCreateClick }: { disabled: boolean; onCreateClick: () => void }) => {
  const translate = useTranslate();
  return (
    <TopToolbar>
      <Button
        label={translate("emptyList.practitioner.createButton")}
        variant="contained"
        disabled={disabled}
        onClick={onCreateClick}
        data-testid="create-button"
      >
        <Add />
      </Button>
    </TopToolbar>
  );
};

export const PractitionerList = () => {
  const translate = useTranslate();
  const { organizationId: selectedOrganizationId } = useOrganizationContext();
  const { locationId: selectedLocationId } = useLocationFilterContext();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const accessStatusChoices = Object.values(ACCESS_STATUS).map(status => ({
    id: status,
    name: translate(`accessStatus.${status}`),
  }));

  const handleCreateClick = () => {
    setIsCreateDialogOpen(true);
  };

  const handleCreateClose = () => {
    setIsCreateDialogOpen(false);
  };

  return (
    <>
      <List
        resource="Practitioner"
        filters={[
          <SearchInput key="search" source="search" alwaysOn />,
          <SelectInput
            key="accessStatus"
            source="accessStatus"
            label={translate("accessStatus.filterLabel")}
            choices={accessStatusChoices}
            alwaysOn
          />,
        ]}
        actions={<PractitionerListActions disabled={!selectedOrganizationId} onCreateClick={handleCreateClick} />}
        title={<ListTitle title="Mitarbeiter" />}
        filter={{ organizationId: selectedOrganizationId, locationId: selectedLocationId }}
        perPage={ROWS_PER_PAGE}
        empty={
          <EmptyList
            image="/images/practitioner.svg"
            description={translate("emptyList.practitioner.description")}
            createButton={{
              label: translate("emptyList.practitioner.createButton"),
              onClick: handleCreateClick,
              disabled: !selectedOrganizationId,
            }}
          />
        }
      >
        <PractitionerDataGrid showAccessStatus bulkActionButtons={<PractitionerBulkOtpAction />} />
      </List>
      {isCreateDialogOpen && <PractitionerCreate open={isCreateDialogOpen} onClose={handleCreateClose} />}
    </>
  );
};
